import React from "react"

import { type IconProps } from "./utils"

export default function GraduateCapIconSolid(props: IconProps) {
  return (
    <svg
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.16658 11.5451V13.3449C4.16658 14.2919 4.70159 15.1575 5.54855 15.581L8.88188 17.2477C9.5857 17.5996 10.4141 17.5996 11.118 17.2477L14.4513 15.581C15.2982 15.1575 15.8333 14.2919 15.8333 13.3449V11.5451L11.1179 13.9027C10.4141 14.2546 9.5857 14.2546 8.88188 13.9027L4.16658 11.5451Z"
        fill="#8B8D98"
      />
      <path
        d="M17.4999 8.84836V12.5C17.4999 12.9602 17.873 13.3333 18.3333 13.3333C18.7935 13.3333 19.1666 12.9602 19.1666 12.5V7.5C19.1666 7.18436 18.9882 6.89581 18.7059 6.75464L10.3726 2.58798C10.138 2.47067 9.86185 2.47067 9.62724 2.58798L1.29391 6.75464C1.01159 6.89581 0.833252 7.18436 0.833252 7.5C0.833252 7.81564 1.01159 8.1042 1.29391 8.24536L9.62724 12.412C9.86185 12.5293 10.138 12.5293 10.3726 12.412L17.4999 8.84836Z"
        fill="#8B8D98"
      />
    </svg>
  )
}
